import React, { useState } from 'react'

import Component from './component'

const Container = ({ initial_toggle }) => {
  const [toggle, setToggle] = useState(initial_toggle)

  const mergedProps = {
    toggle,
    setToggle
  }

  return (
    <Component {...mergedProps} />
  )
}

export default Container
